<template>
  <div class="banner-wrap">
    <div class="banner-scroll">
      <div class="banner">
        <div v-show="imgShow" style="height: 100%; width: 100%">
          <img
            v-if="this.imgList.length < 1"
            src="../../static/webp1/banner1@2x.webp"
            class="banner-bg"
          />
          <Carousel
            v-else
            :autoplay="this.imgList.length > 1 ? true : false"
            :autoplay-speed="4000"
            loop
          >
            <CarouselItem style="height: 300px;" v-for="(item, index) in imgList" :key="index">
              <img :src="item.image" class="banner-bg" />
              <!-- <div class="banner-bg">1</div> -->
            </CarouselItem>
          </Carousel>
        </div>
      </div>
      <!-- <div class="banner banner2">
          <div class="banner-bg"></div>
          <div class="banner-content">
          </div>
       </div>
       <div class="banner banner3">
              <div class="banner-bg"></div>
              <div class="banner-content">
              </div>
           </div> -->
    </div>
    <ul class="buddle"></ul>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      imgList: [],
      value: 0,
      imgShow: false
    };
  },
  mounted() {
    this.getImg();
  },
  methods: {
    getImg() {
      GMS.$http
        .get("/carousel/getCarousel")
        .then(res => {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].type == "first" && res.data[i].image) {
              this.imgList.push(res.data[i]);
            }
          }
          this.imgList = this.imgList.sort(this.sortby("ordina"));
          this.imgShow = true;
          //  console.log('第一版轮播图',this.imgList)
        })
        .catch(error => {
          this.imgShow = true;
          console.log("轮播图", error);
        });
    },
    sortby(prop, rev = true) {
      return function(a, b) {
        var val1 = a[prop];
        var val2 = b[prop];
        return rev ? val1 - val2 : val2 - val1;
      };
    }
  }
};
</script>

<style lang="less" scoped>
.banner-wrap {
  width: 100%;
  height: 300px;
  position: relative;
  overflow: hidden;
  min-width: 1180px;
  .banner-scroll {
    width: 100%;
    height: 300px;
    position: relative;
    overflow: hidden;
    min-width: 1180px;
  }
  .banner {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .buddle {
    position: absolute;
    bottom: 20px;
    height: 4px;
    z-index: 10;
    left: 50%;
    margin-left: -27px;
  }
  .buddle li {
    width: 22px;
    height: 4px;
    background: #ffffff;
    border-radius: 100px;
    float: left;
    margin-right: 10px;
    opacity: 0.5;
    cursor: pointer;
  }
  .buddle li:last-child {
    margin-right: 0;
  }

  // .banner-bg {
  //   position: absolute;
  //   left: 0;
  //   top: 0;
  //   width: 100%;
  //   height: 100%;
  //   overflow: hidden;
  //   z-index: -1;
  // }
  // .banner-bg {
  //   background: #fff none no-repeat center center;
  //   -webkit-background-size: cover;
  //   -moz-background-size: cover;
  //   -o-background-size: cover;
  //   background-size: cover;
  //   background-image:url('../../static/webp1/banner1@2x.webp');
  //   position: absolute;
  //   left: 0;
  //   top: 0;
  //   width: 100%;
  //   height: 100%;
  //   overflow: hidden;
  //   z-index: -1;
  // }
  .banner-bg {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  .banner2 .banner-bg {
    background: url("../../static/webp1/banner1@2x.webp") no-repeat;
    background-size: 1920px;
  }
  .banner3 .banner-bg {
    background: url("../../static/webp1/banner1@2x.webp") no-repeat;
    background-size: 1920px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue